import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useFeliz_React__React_useProjectContext_Static } from "../hooks/UseProjectContext.fs.js";
import { createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.Bulma.3.0.0/./ElementBuilders.fs.js";
import { map, mapIndexed, ofArray, singleton as singleton_1 } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { defaultOf } from "../fable_modules/Feliz.2.9.0/../Feliz.Router.4.0.0/../fable-library-js.4.24.0/Util.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";

export function Header() {
    let elems_1;
    const context = useFeliz_React__React_useProjectContext_Static();
    const xs_7 = [createElement("div", createObj(ofArray([["className", join(" ", ["entity-header", "with-image"])], (elems_1 = toList(delay(() => append(singleton(createElement("p", createObj(Helpers_combineClasses("title", singleton_1(["children", context.Config.Name]))))), delay(() => {
        let matchValue;
        return append((matchValue = context.Config.Description, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
            className: "subtitle",
            children: matchValue,
        }))), delay(() => {
            let elems;
            const matchValue_1 = context.Config.ImageUrl;
            return (matchValue_1 != null) ? singleton(createElement("figure", createObj(Helpers_combineClasses("image", ofArray([["className", "is-5by3"], ["className", "is-fullwidth"], (elems = [createElement("img", {
                src: matchValue_1,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))) : singleton(defaultOf());
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))];
    return react.createElement(react.Fragment, {}, ...xs_7);
}

export function ProjectInfoPanel() {
    const xs_5 = mapIndexed((i, panel) => {
        let elems_1;
        return createElement("details", createObj(ofArray([["key", i], ["open", true], (elems_1 = toList(delay(() => append(singleton(createElement("summary", {
            children: [panel.Name],
        })), delay(() => map((v) => {
            let elems, matchValue;
            return createElement("div", createObj(ofArray([["className", "key-value"], (elems = [createElement("span", {
                className: "key",
                children: v.Name,
            }), createElement("span", {
                className: "value",
                children: (matchValue = v.Url, (matchValue != null) ? createElement("a", {
                    href: matchValue,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: v.Value,
                }) : v.Value),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, panel.Values))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    }, useFeliz_React__React_useProjectContext_Static().Config.ProjectInfoPanel);
    return react.createElement(react.Fragment, {}, ...xs_5);
}

